export default __webpack_public_path__ + "static/media/263698.b8cdcc10.png";